// components/SortableItem.js
import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const SortableItem = ({ id, slide, activeSlide, setActiveSlide, handleDeleteSlide }) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    backgroundColor: slide.id === activeSlide ? "blue" : "transparent", // Highlight active slide in blue
    color: slide.id === activeSlide ? "white" : "black", // Ensure text is visible
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className={`slide-list-item ${slide.id === activeSlide ? 'active' : ''}`}
    >
      <button className="slide-button" onClick={() => setActiveSlide(slide.id)}>
        {slide.title}
      </button>
      <button className="delete-slide-button" onClick={() => handleDeleteSlide(slide.id)}>
        x
      </button>
    </div>
  );
};

export default SortableItem;
